import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCheckInShieldWithDiamond(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={108}
      height={109}
      fill="none"
      {...props}
    >
      <path
        fill="#169563"
        d="M.645 6.002 11.275.154a1.24 1.24 0 0 1 1.2 0l10.63 5.848a1.244 1.244 0 0 1 .425 1.796L12.898 23.213a1.244 1.244 0 0 1-2.046 0L.22 7.798a1.244 1.244 0 0 1 .425-1.796"
      />
      <g clipPath="url(#CheckInShieldWithDiamond_svg__a)">
        <path
          fill="url(#CheckInShieldWithDiamond_svg__b)"
          d="M106.239 18.84c-25.758 0-37.276-13.118-37.386-13.247-.67-.79-2.037-.79-2.706 0-.112.132-11.51 13.247-37.386 13.247-.972 0-1.761.776-1.761 1.733v33.09c0 18.09 8.259 35.28 22.092 45.984 5.577 4.316 11.6 7.438 17.906 9.28a1.8 1.8 0 0 0 1.004 0c6.305-1.843 12.33-4.964 17.906-9.28C99.741 88.942 108 71.753 108 53.663v-33.09c0-.957-.787-1.733-1.761-1.733m-8.893 34.823c0 14.896-6.738 29.003-18.021 37.736-3.748 2.9-7.717 5.127-11.825 6.637-4.106-1.508-8.074-3.735-11.823-6.637-11.285-8.731-18.021-22.837-18.021-37.736V28.85c9.009-.99 17.384-3.494 24.586-7.388a54 54 0 0 0 5.274-3.242 55 55 0 0 0 5.296 3.245c7.208 3.886 15.566 6.388 24.535 7.38v24.819h-.001Z"
        />
        <path
          stroke="#0C1C43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="m55.131 56.88 7.776 7.776 9.072-10.368 9.072-10.368"
        />
      </g>
      <defs>
        <linearGradient
          id="CheckInShieldWithDiamond_svg__b"
          x1={67.5}
          x2={67.5}
          y1={5}
          y2={109}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
        <clipPath id="CheckInShieldWithDiamond_svg__a">
          <path fill="#fff" d="M27 5h81v104H27z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCheckInShieldWithDiamond);
export default ForwardRef;
